import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "bubble-speech",
  "use": "bubble-speech-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"bubble-speech\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.025 12.816L8 15l2.027-2.194.158-.032C13.541 12.06 16 9.745 16 7c0-3.314-3.582-6-8-6S0 3.686 0 7c0 2.733 2.437 5.04 5.77 5.764l.255.052zm3.952-1.02l-.465.093L8 13.5l-1.456-1.601-.562-.112C3.012 11.14 1 9.162 1 7c0-2.689 3.082-5 7-5s7 2.311 7 5c0 2.174-2.031 4.16-5.023 4.795zM4 5h8v1H4V5zm6 3H4v1h6V8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol